import React, { useEffect, useState } from 'react';
import { animate, motion, useMotionValue, useTransform } from 'framer-motion';
import { EASE_IN_OUT, EASE_OUT } from './motion';
import { site } from '../content';

/** A brief curtain with a counter. Shown once per browser session. */
export function Loader({ onDone }: { onDone: () => void }) {
  const [leaving, setLeaving] = useState(false);
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => String(Math.round(v)).padStart(3, '0'));

  useEffect(() => {
    const controls = animate(count, 100, {
      duration: 1.3,
      ease: [0.65, 0, 0.35, 1],
      onComplete: () => {
        setLeaving(true);
        onDone();
      },
    });
    return () => controls.stop();
  }, [count, onDone]);

  return (
    <motion.div
      className="loader"
      style={{ pointerEvents: leaving ? 'none' : 'auto' }}
      initial={{ clipPath: 'inset(0 0 0% 0)' }}
      animate={leaving ? { clipPath: 'inset(0 0 100% 0)' } : undefined}
      transition={{ duration: 1, ease: EASE_IN_OUT }}
      aria-hidden="true"
    >
      <div className="loader__inner wrap">
        <span className="loader__name">
          <motion.span
            initial={{ y: '110%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 0.9, ease: EASE_OUT }}
          >
            {site.name} <span className="serif">Studio</span>
          </motion.span>
        </span>
        <motion.span className="loader__count mono">{rounded}</motion.span>
      </div>
    </motion.div>
  );
}
